import Parse from 'html-react-parser';

function BMP20219(props) {
    let svgCode =
    `<svg width="46" height="78" viewBox="0 0 46 78" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="2" y="2" width="18" height="22" fill="${props.darkFill}"/>
        <path d="M16 6.5L7.5 14L16 21" stroke="${props.highlightColour}" stroke-width="5"/>
        <rect width="18" height="22" transform="matrix(-1 0 0 1 44 54)" fill="${props.darkFill}"/>
        <path d="M30 58.5L38.5 66L30 73" stroke="${props.highlightColour}" stroke-width="5"/>
        <rect width="18" height="22" transform="matrix(-1 0 0 1 44 28)" fill="${props.darkFill}"/>
        <path d="M30 32L38.5 39.5L30 46.5" stroke="black" stroke-width="5"/>
        <rect width="18" height="22" transform="matrix(-1 0 0 1 44 2)" fill="${props.darkFill}"/>
        <path d="M30 6L38.5 13.5L30 20.5" stroke="black" stroke-width="5"/>
        <rect x="2" y="54" width="18" height="22" fill="${props.darkFill}"/>
        <path d="M16 58L7.5 65.5L16 72.5" stroke="black" stroke-width="5"/>
        <rect x="2" y="28" width="18" height="22" fill="${props.darkFill}"/>
        <path d="M16 32L7.5 39.5L16 46.5" stroke="black" stroke-width="5"/>
    </svg>`

    props.svgReturn(54, svgCode, "bmp00219", 46, 78);

    const style = {
        display: props.display
    }

    return (
        <div style={style}>
            {Parse(svgCode)}
        </div>
    );
}

export default BMP20219;